<template>
  <div>
    <v-container v-if="pageLoading" grid-list-xl text-xs-center>
        <v-layout>
            <v-flex>
                <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                ></v-progress-circular>
            </v-flex>
        </v-layout>
    </v-container>
    <v-stepper
      v-if="family && settings"
      alt-labels
      v-model="e1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1" @click="goToNextStep(1, family)" style="cursor: pointer;">{{ $t(`admissions.titles.form`) }}</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 2" step="2">{{ $t(`admissions.titles.signature`) }}</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 3" step="3">{{ $t(`admissions.titles.payment`) }}</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step :complete="e1 > 4" step="4">{{ $t(`admissions.titles.appointments`) }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step v-if="family && family[family.length - 1].score && family[family.length - 1].score.continua" :complete="e1 > 5" step="5">Consejería</v-stepper-step>
        <!-- <v-stepper-step v-if="family[family.length - 1].score.continua" :complete="e1 > 5" step="5">Consejería</v-stepper-step> -->
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <div v-if="family[family.length - 1].current_step == 0">
            <v-layout column justify-center align-center >
              <v-flex xs6>
                <v-alert type="info" :value="true">
                  <h3>
                    Admisiones
                  </h3>
                  <h4>
                    {{ settings.submitted_message }}
                  </h4>
                </v-alert>
              </v-flex>
            </v-layout>
          </div>
          <admissions-step-1
            :family="family"
            :settings="settings"
            v-on:goToNextStep="goToNextStep"
          ></admissions-step-1>
        </v-stepper-content>

        <v-stepper-content step="2">
          <admissions-step-2
            :family="family"
            :settings="settings"
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></admissions-step-2>
        </v-stepper-content>

        <v-stepper-content step="3">
          <admissions-step-3
            v-if="family && family[0].siesa_tercero_id"
            :family="family"
            :settings="settings"
            :id_pago="id_pago"
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></admissions-step-3>
        </v-stepper-content>

        <v-stepper-content step="4">
          <admissions-step-4
            v-if="family && settings && (family[0].current_step >= 4 || family[0].current_step === 0)"
            :family="family"
            :quote_id="settings.quote_id"
            step="4"
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></admissions-step-4>
        </v-stepper-content>

        <!-- <v-stepper-content step="5" v-if="family[0].score.continua"> -->
        <v-stepper-content step="5" v-if="family && family[0].score && family[0].score.continua">
          <admissions-step-4
            :family="family"
            :quote_id="settings.quote2_id"
            step="5"
            v-on:goToNextStep="goToNextStep"
            v-on:goToPrevStep="goToPrevStep"
          ></admissions-step-4>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
  import axios from 'axios'
  import admissionsStep1 from './admissions_step1.vue'
  import admissionsStep2 from './admissions_step2.vue'
  import admissionsStep3 from './admissions_step3.vue'
  import admissionsStep4 from '~/pages/responsibleAppointment/showResponsibleQuote.vue'
  export default {
    name: 'student-admissions-view',
    components: {
      'admissions-step-1': admissionsStep1,
      'admissions-step-2': admissionsStep2,
      'admissions-step-3': admissionsStep3,
      'admissions-step-4': admissionsStep4,
    },
    data() {
      return {
        e1: 1,
        pageLoading: false,
        family: null,
        settings: null,
        id_pago: null,
      }
    },
    created () {
      this.init()
      const idPago = this.$route.query.idPago
      this.id_pago = idPago
    },
    methods: {
      async init() {
        axios.get('/api/admissions/get_admissions_info')
          .then(resp => {
            if (resp.status === 200) {
              this.family = resp.data

              if (this.id_pago) {
                this.goToNextStep(3, this.family)
              }
            }
          })
          .catch(error => console.log(error))
          
        axios.get('/api/admissions/get_settings')
          .then(resp => {
            if (resp.status === 200) {
              this.settings = resp.data[0]
            }
          })
          .catch(error => console.log(error))
      },
      goToNextStep(step, family) {
        this.e1 = step
        this.family = family
      },
      goToPrevStep(step) {
        this.e1 = step
      },
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/form.vue